
// Libraries
import { defineComponent } from 'vue';

// Components
import DuoView from 'client/containers/user/Views/DuoView.vue';

// Services
import duoConfigService from 'client/services/duoConfigService';
import userResetPasswordService from 'client/services/userResetPasswordService';

// Constants
import { useMfaLabels } from 'client/util/Constants/MfaLabels';

export default defineComponent({
  name: 'DuoUserResetPasswordHandler',

  components: {
    DuoView,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      required: true,
    },
    requestKey: {
      type: String,
      required: true,
    },
  },

  setup() {
    const uiLabel = useMfaLabels();
    return { uiLabel };
  },

  data() {
    return {
      isLoading: true,
      showFrame: false,
      token: '',
    };
  },

  mounted() {
    this.handleDuoSetUp();
  },

  methods: {
    async handleDuoSetUp(): Promise<void> {
      try {
        const token = await duoConfigService.setUpDuoForPasswordReset(
          this.form.challenge.duo,
          this.submitPasswordReset,
        );

        this.showFrame = true;
        this.token = token;
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.isLoading = false;
      }
    },

    // eslint-disable-next-line no-undef
    async submitPasswordReset(form: DuoForm) {
      try {
        const passwordResetInfo = {
          ...this.form,
          sig_response: form.elements.sig_response.value,
          token: this.token,
        };

        await userResetPasswordService.resetPassword(
          this.requestKey,
          passwordResetInfo,
        );
        this.$emit('success');
      } catch (error) {
        this.$emit('error', error);
      }
    },
  },
});
